import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    failedPhysicianDutiesErrors(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('doctor-id/api-transaction-history/failed-physician-duties', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
